
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrandingProvider } from './context/BrandingContext';
import reportWebVitals from './reportWebVitals';


// ── Console guard: suppress all output in production unless debug mode active ──
if (process.env.NODE_ENV === 'production') {
  const _noop = () => {};
  const _originals: Record<string, any> = {};
  (['log', 'debug', 'info', 'warn', 'error', 'table', 'dir'] as const).forEach(m => {
    _originals[m] = (console as any)[m];
    (console as any)[m] = _noop;
  });
  // Called from DiagnosticsPage or debug unlock flow to re-enable logging
  (window as any).__ceEnableConsole = (until: number) => {
    (['log', 'debug', 'info', 'warn', 'error', 'table', 'dir'] as const).forEach(m => {
      (console as any)[m] = _originals[m];
    });
    setTimeout(() => {
      (['log', 'debug', 'info', 'warn', 'error', 'table', 'dir'] as const).forEach(m => {
        (console as any)[m] = _noop;
      });
    }, Math.max(0, until - Date.now()));
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrandingProvider>
      <App />
    </BrandingProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
